var _circle, _path, _rect, _polygon, _polygon2, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 650 650",
    style: {
      enableBackground: "new 0 0 650 650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 325,
    cy: 270.1,
    r: 134
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M446.1,380.9c-30.4,32.2-73.3,52.3-121.1,52.3c-47.7,0-90.7-20.1-121.1-52.3c-52.3,37.7-86.4,99.1-86.4,168.5 c0,10.2,0.8,20.3,2.2,30.1c60.4,34.9,130.5,54.9,205.3,54.9s144.9-20,205.3-54.9c1.4-9.8,2.2-19.9,2.2-30.1 C532.5,480,498.4,418.5,446.1,380.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 203.8,
    y: 119.4,
    width: 242.5,
    height: 124.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "325,243.3 114.2,122.4 325,15.7 535.8,122.4 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "137.7,400.8 117.5,341.6 138.7,119.4 159.9,342.2 "
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.7,
    cy: 169.1,
    r: 18.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/Student.05c08078.svg";
export { ForwardRef as ReactComponent };